"use client";

import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {withStyleContext} from "@gluestack-ui/nativewind-utils/withStyleContext";
import {createPressable} from "@gluestack-ui/pressable";
import type {Ref} from "react";
import React from "react";
import {Pressable as RNPressable} from "react-native";

const UIPressable = createPressable({
    Root: withStyleContext(RNPressable)
});

const pressableStyle = tva({
    base: "data-[focus-visible=true]:outline-none data-[focus-visible=true]:ring-indicator-info data-[focus-visible=true]:ring-2 data-[disabled=true]:opacity-40"
});

export type BasePressableProps = Omit<React.ComponentProps<typeof UIPressable>, "context"> &
    VariantProps<typeof pressableStyle>;

export type IPressableProps<T = never> = IsNever<T> extends true
    ? BasePressableProps
    : React.ComponentProps<"button"> & {
          // extra ones from the native
          testID?: string;
          onPress?: () => void;
      };

export type PressableRef<T = never> = IsNever<T> extends true
    ? React.ComponentRef<typeof UIPressable>
    : HTMLButtonElement;

const Pressable = React.forwardRef<PressableRef, IPressableProps>(({className, ...props}, ref) => {
    return (
        <UIPressable
            {...props}
            ref={ref}
            className={pressableStyle({
                class: className
            })}
        />
    );
}) as {
    <T = never>(props: IPressableProps<T> & {ref?: Ref<PressableRef<T>>}): React.ReactElement<any>;
    displayName: string;
};

Pressable.displayName = "Pressable";
export {Pressable};
